<template>
  <view>
    <view class="c-float-tools" :style="computeStyle">
      <!-- 浮窗 -->
      <view
        v-if="computeFloatingWindowWhiteList && isOpenFloatingWindow && floatingWindowData"
        class="item"
        @click="handleCouponClick"
      >
        <view class="coupon-item" :style="computeCouponItemStyle">
          <!-- 已领取 -->
          <c-img
            v-if="isReceivedFloatingWindowCoupon"
            :src="floatingWindowData.floatingWindowImageReceived"
          />
          <!-- 未领取 -->
          <c-img v-else :src="floatingWindowData.floatingWindowImage" />
        </view>
      </view>

      <!-- 分享赚 -->
      <c-img
        v-if="computeShareEarnWhiteList && appStore.distributorData && !shareEarnOptions.hidden"
        class="item"
        remote-name="home_share"
        @click="handleShareClick"
      />

      <view class="item item--not-margin" v-if="showShoppingCart" @click="handleShoppingCartClick">
        <view class="common-inner shopping-cart">
          <uv-icon name="shopping-cart" color="#333" size="28" />
        </view>
      </view>














    </view>

    <share-earn-popup ref="shareEarnPopupRef" :share-value="shareEarnOptions.shareValue" />
  </view>
</template>

<script setup lang="ts">
import ShareEarnPopup from '@/components/share-earn-popup/index.vue';
import { PAGE_PATH } from '@/constants';
import { fetchFloatingWindow, fetchGetFloatingWindowCouponRecord } from '@/services';
import { useAppStore, useUserStore } from '@/store';
import { businessUtils, commonUtils } from '@/utils';
import { onShow } from '@dcloudio/uni-app';
import { computed, ref, toRefs } from 'vue';

interface Props {
  position?: {
    bottom?: number;
    right?: number;
  };
  showCustomerService?: boolean;
  showShoppingCart?: boolean;
  /** 分享赚数据 */
  shareEarnOptions?: {
    shareValue: string;
    hidden?: boolean;
  };
}
const props = withDefaults(defineProps<Props>(), {
  showCustomerService: false,
  showShoppingCart: false,
  shareEarnOptions: () => ({
    shareValue: '',
    hidden: false,
  }),
});
const { position, shareEarnOptions, showCustomerService, showShoppingCart } = toRefs(props);

const userStore = useUserStore();
const appStore = useAppStore();

// 分享赚弹窗
const shareEarnPopupRef = ref<InstanceType<typeof ShareEarnPopup>>();
// 优惠券浮窗数据
const floatingWindowData = ref<AnyObject>();
// 是否开启优惠券浮窗
const isOpenFloatingWindow = ref<boolean>(false);
// 是否已领取优惠券
const isReceivedFloatingWindowCoupon = ref<boolean>(false);

/** 浮窗样式 */
const computeStyle = computed(() => {
  let style = {};

  if (position?.value) {
    style = {
      ...style,
      bottom: `${position.value.bottom}rpx`,
      right: `${position.value.right}rpx`,
    };
  }

  return style;
});

/** 浮窗优惠券样式 */
const computeCouponItemStyle = computed(() => {
  let style = {};

  const _data = floatingWindowData.value;
  if (_data?.width && _data?.height) {
    style = {
      width: `${_data.width * 2}rpx`,
      height: `${_data.height * 2}rpx`,
    };
  }

  return style;
});

/** 浮窗白名单 */
const computeFloatingWindowWhiteList = computed(() => {
  const pages = getCurrentPages();
  const currentPage = `/${pages[pages.length - 1].route}`;
  const isMatch = [PAGE_PATH.activity.route, PAGE_PATH.commodity.route].includes(currentPage);
  return commonUtils.tabbar.is() || isMatch;
});

// 分享赚白名单
const computeShareEarnWhiteList = computed(() => {
  const pages = getCurrentPages();
  const currentPage = `/${pages[pages.length - 1].route}`;
  return [
    PAGE_PATH.home.route,
    PAGE_PATH.classify.route,
    PAGE_PATH.activity.route,
    PAGE_PATH.searchResult.route,
    PAGE_PATH.memberDetail.route,
    PAGE_PATH.member.route,
    PAGE_PATH.memberGiftCard.route,
    PAGE_PATH.commodity.route,
    PAGE_PATH.blindBoxActivity.route,
    PAGE_PATH.integralCommodity.route,
    PAGE_PATH.couponDetail.route,
    PAGE_PATH.signIn.route,
  ].includes(currentPage);
});

/** 浮窗优惠券点击 */
const handleCouponClick = () => {
  // console.log('浮窗优惠券点击', floatingWindowData.value);
  businessUtils.mp.customJump(
    floatingWindowData.value?.jumpValue,
    floatingWindowData.value?.jumpType
  );
};

/** 分享赚点击 */
const handleShareClick = () => {
  businessUtils.matomo.customPageClick();
  shareEarnPopupRef.value?.open();
};

/** 浮窗优惠券处理 */
const couponHandler = async () => {
  try {
    // 非浮窗白名单不处理
    if (computeFloatingWindowWhiteList.value) {
      // 获取浮窗优惠券记录
      isReceivedFloatingWindowCoupon.value = await fetchGetFloatingWindowCouponRecord();
      // console.log(`是否已领取: ${JSON.stringify(isReceivedFloatingWindowCoupon.value)}`);

      // 获取浮窗数据
      const floatingWindowRes = await fetchFloatingWindow();
      // console.log(`浮窗数据`, floatingWindowRes);

      // 是否开启
      let isOpen = floatingWindowRes?.isOpen;
      // 如果是领取后不开启，且用户已领取，则最终不开启
      if (!floatingWindowRes?.isShowAfterReceived && isReceivedFloatingWindowCoupon.value) {
        isOpen = false;
      }

      isOpenFloatingWindow.value = isOpen;
      floatingWindowData.value = floatingWindowRes;
    }
  } catch (error) {
    console.error(`error: ${error}`);
  }
};

/** 购物车点击 */
const handleShoppingCartClick = () => {





  uni.reLaunch({ url: PAGE_PATH.cart.route });

};

onShow(() => {
  couponHandler();
});
</script>

<style scoped lang="scss">
.c-float-tools {
  position: fixed;
  right: 0;






  bottom: 380rpx;


  z-index: 991;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .item {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 152rpx;
    height: 152rpx;
    margin-bottom: 40rpx;

    &.item--not-margin {
      margin-bottom: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }

    .coupon-item {
      width: 180rpx;
      height: 180rpx;
    }

    .common-inner {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100rpx;
      height: 100rpx;
      border-radius: 50%;
      background: $W;
      @include shadow;
    }

    .service-customer {
    }

    .shopping-cart {
    }
  }
}
</style>
